import React from 'react';
import { Table } from 'antd';
import styled from 'styled-components';
import 'antd/dist/antd.css';

const SubTableSection = styled(Table)`
  .ant-table-tbody > tr > td {
    font-weight: normal;
  }
`;
const OptionTwoWrapper = styled.div`
  display: inline-block;
  position: relative;
`;
const ItemPreviewImage = styled.img`
  position: relative;
  display: inline-block;
  border-radius: 5px;
  width: 60px;
  height: 60px;
  &.full-image {
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }
`;
const AddOptionImage = styled.label`
  all: unset;
  position: relative;
  display: inline-block;
  width: 80px;
  height: 80px;
  box-sizing: border-box;
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  border-radius: 5px;
  text-align: center;
  font-size: 12px;
  &.mark {
    border: 2px solid ${(props) => props.theme.colors.blue};
  }
`;
const Register = styled.div`
  line-height: 80px;
`;
const Mark = styled.div`
  position: absolute;
  margin: 5px;
  width: 24px;
  background: ${(props) => props.theme.colors.blue};
  border-radius: 2px;
  color: #fff;
  font-size: 10px;
  text-align: center;
  z-index: 1;
`;

function FreebieSubTable({ record, index }) {
  const items = record.items;

  const data = [];
  for (let i = 0; i < items.length; i++) {
    data.push({
      key: items[i].id,
      name: items[i].name,
      image: items[i].image,
      mainImage: items[i].mainImage,
    });
  }

  const columns = [
    {
      title: '이미지',
      key: 'image',
      width: '30%',
      render: (option) => (
        <OptionTwoWrapper>
          {option.mainImage && <Mark>대표</Mark>}
          <AddOptionImage
            className={option.mainImage && 'mark'}
            htmlFor={'markImage' + index + option.key}
          >
            {option.image ? (
              <ItemPreviewImage className="full-image" src={option.image} />
            ) : (
              <Register>이미지 없음</Register>
            )}
          </AddOptionImage>
        </OptionTwoWrapper>
      ),
    },
    {
      title: '옵션명',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <SubTableSection columns={columns} dataSource={data} pagination={false} />
  );
}

export default FreebieSubTable;
